import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { GroupIntroFeedbackPromptComponent } from '@main-client/src/app/group-intro-feedback-prompt/group-intro-feedback-prompt.component';

@NgModule({
  declarations: [GroupIntroFeedbackPromptComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    NzToolTipModule,
    RouterModule,
  ],
  exports: [GroupIntroFeedbackPromptComponent],
})
export class GroupIntroFeedbackPromptModule {}
